import { __rest } from "tslib";
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../theme';
import { ModalX } from '../../BaseComponents';
import CustomerContactsForm from '../CustomerContactsForm';
const CustomerContactsModal = (_a) => {
    var { initialValues, onContactsSubmit, isLoading } = _a, props = __rest(_a, ["initialValues", "onContactsSubmit", "isLoading"]);
    const { t } = useTranslation('CustomerContactsForm');
    const { CustomerContactsModal: css } = useTheme('CustomerContactsForm');
    return (React.createElement(ModalX, Object.assign({ size: "medium", title: React.createElement("span", { className: css.saveContactInfo__title }, t('Please, enter your contacts')) }, props),
        React.createElement(CustomerContactsForm, { initialValues: initialValues, onContactsSubmit: onContactsSubmit, isLoading: isLoading })));
};
export default CustomerContactsModal;
